import { render } from "./ReserveLocker.vue?vue&type=template&id=55b023db&scoped=true&ts=true"
import script from "./ReserveLocker.vue?vue&type=script&lang=ts"
export * from "./ReserveLocker.vue?vue&type=script&lang=ts"

import "./ReserveLocker.vue?vue&type=style&index=0&id=55b023db&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b023db"]])

export default __exports__